import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ReceptionStatusProvidersQueryDocument } from '@docpace/reception-status-graphql/dist/urql.types'
import { ReceptionStatusProvidersQueryResultFragment } from '@docpace/reception-status-graphql'

const typedReceptionStatusProvidersQueryDocument = ReceptionStatusProvidersQueryDocument as TypedDocumentNode<ReceptionStatusProvidersQueryResultFragment>

export function useReceptionStatusProvidersQuery(opts?: useQuery.Options<ReceptionStatusProvidersQueryResultFragment>){
    return useQuery(typedReceptionStatusProvidersQueryDocument, opts)
}
